import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { RestrictedGatewayFormSchemaValues } from 'src/features/membershipType/formSchema';
import { restrictedGatewayMessages } from 'src/features/membershipType/utils/messages';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';
import { useListGateways } from 'src/features/gateway/api/useListGateways';
import { useParking } from 'src/providers/ParkingProvider';

type RestrictedGatewayFormProps = {
    form: UseFormReturn<RestrictedGatewayFormSchemaValues>;
    onSubmit: (values: RestrictedGatewayFormSchemaValues) => void;
};

function RestrictedGatewayForm({ onSubmit, form }: RestrictedGatewayFormProps) {
    const { formatMessage, locale } = useIntl();
    const { membershipTypeId = ''} = useParams();
    const { parkingId } = useParking();

    const { data: gatewayListData } = useListGateways({
        parkingId,
        restricted_membership_type: membershipTypeId,
    });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <FormField
                control={form.control}
                name="gatewayId"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...restrictedGatewayMessages.restrictedGateway} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select onValueChange={field.onChange} value={field.value}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue
                                            placeholder={`${formatMessage(restrictedGatewayMessages.restrictedGateway)}...`}
                                        />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {gatewayListData?.results?.map((option) => (
                                            <SelectItem key={option.id} value={option.id}>
                                                {option?.translations?.find((t) => t.language === locale)?.name}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
}

export default RestrictedGatewayForm;
